import { SwitchBox, SwitchBoxToggle, SwitchWrapper } from "./switch.styles";
import { SwitchProps } from "./switch.types";

export const Switch = ({
  isActive,
  mt,
  mb,
  ml,
  mr,
  onClick,
  id,
  disabled,
}: SwitchProps) => {
  const toggle = (
    <SwitchWrapper
      ml={ml}
      mr={mr}
      mt={mt}
      mb={mb}
      onClick={!disabled ? onClick : undefined}
    >
      <SwitchBox
        type="checkbox"
        checked={isActive}
        readOnly={true}
        disabled={disabled}
      />
      <SwitchBoxToggle
        htmlFor="switch"
        {...(id && { id })}
        disabled={disabled}
      />
    </SwitchWrapper>
  );

  return <>{toggle}</>;
};
